import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { MathEnabledTextComponent, TextLinkButton, styleVariables } from '@lib/common';
import { Space } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledTruncatedText = styled.div.withConfig({
  displayName: "essay-answer-editor-previewcomponent__StyledTruncatedText",
  componentId: "sc-nfvsvs-0"
})(["overflow:hidden;text-overflow:ellipsis;max-height:", ";"], function (props) {
  return props.isShortView ? "".concat(props.maxHeight, "px") : 'none';
});
var StyledAnswerContent = styled.div.withConfig({
  displayName: "essay-answer-editor-previewcomponent__StyledAnswerContent",
  componentId: "sc-nfvsvs-1"
})(["line-height:12px;font-size:16px;padding:4px;"]);
var StyledAnswerPlaceholderContent = styled.div.withConfig({
  displayName: "essay-answer-editor-previewcomponent__StyledAnswerPlaceholderContent",
  componentId: "sc-nfvsvs-2"
})(["line-height:12px;font-size:16px;opacity:0.5;padding:8px;overflow:hidden;"]);
var StyledSpace = styled(Space).withConfig({
  displayName: "essay-answer-editor-previewcomponent__StyledSpace",
  componentId: "sc-nfvsvs-3"
})(["width:100%;display:flex;align-items:center;justify-content:space-between;border:1px solid ", ";border-radius:", ";padding:8px;cursor:pointer;margin-bottom:8px;transition:background-color 0.3s ease;overflow:hidden;&:hover{background-color:", ";}"], styleVariables.colors.gray3, styleVariables.borderRadius.small, styleVariables.colors.gray3);
export var EssayAnswerEditorPreviewComponent = function EssayAnswerEditorPreviewComponent(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? 180 : _ref$maxHeight,
      onChangeEditMode = _ref.onChangeEditMode,
      label = _ref.label;
  var divRef = useRef(null);
  var truncatedRef = useRef(null);

  var _useState = useState(true),
      isShortView = _useState[0],
      setIsShortView = _useState[1];

  var _useState2 = useState(0),
      height = _useState2[0],
      setHeight = _useState2[1];

  useEffect(function () {
    if (!divRef.current) return;
    var resizeObserver = new ResizeObserver(function () {
      var _divRef$current;

      setHeight((_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.offsetHeight);
    });
    resizeObserver.observe(divRef.current);
    return function () {
      return resizeObserver.disconnect();
    };
  }, [value]);

  var renderMoreButton = function renderMoreButton() {
    var contentHeight = height || 0;

    if (contentHeight <= maxHeight) {
      return null;
    }

    var toggleView = function toggleView() {
      return setIsShortView(!isShortView);
    };

    var buttonText = isShortView ? label.seeMore : label.seeLess;
    return /*#__PURE__*/_jsx(TextLinkButton, {
      onClick: toggleView,
      children: buttonText
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledSpace, {
      onClick: onChangeEditMode,
      children: /*#__PURE__*/_jsxs(StyledTruncatedText, {
        ref: truncatedRef,
        isShortView: isShortView,
        maxHeight: maxHeight,
        children: [(!value || value === '' || value === '<p></p>') && (label === null || label === void 0 ? void 0 : label.inputAnswer) && /*#__PURE__*/_jsx(StyledAnswerPlaceholderContent, {
          children: label.inputAnswer
        }), /*#__PURE__*/_jsx(MathEnabledTextComponent, {
          value: value
        })]
      })
    }), renderMoreButton()]
  });
};